import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  NumberField,
  ReferenceManyField,
  Datagrid,
} from 'react-admin';

export const AttributeGroupShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="slug" />
      <TextField source="description" />
      <NumberField source="sortOrder" />
      
      <ReferenceManyField reference="attributes" target="groupId" label="Attributes">
        <Datagrid>
          <TextField source="name" />
          <TextField source="slug" />
          <NumberField source="sortOrder" />
        </Datagrid>
      </ReferenceManyField>
      
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
